import {
    MapOptions,
    BaseLayerType   
} from "@esdm/map/dist";
import { LayerGroupCollection } from "@esdm/map/dist/layers/groups/LayerGroupCollection";

export const ColchesterBaseLayers = {
    ...BaseLayerType,
    OS: 999
};

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [ColchesterBaseLayers.OSM, ColchesterBaseLayers.OS, ColchesterBaseLayers.BingAerial];
        opt.defaultBaseMap = BaseLayerType.OSM;
        opt.enableBoundsTracking = true;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 13;
        opt.minZoom = 11;
        opt.maxZoom = 18;
        opt.maxZoomToBounds = 16;
        opt.extent = [69099, 6757186, 141102, 6804806];
        opt.mapCentre = [99458, 6779744];
        opt.displayProjection = "EPSG:3857";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;
        
        return opt;
    }

}